import { Component, Children } from 'react';
import PropTypes from 'prop-types';

// Minimal react-helmet replacement for this site's usage: <title> sets
// document.title, <meta id=".."> updates the matching static tag in index.html.
// Like react-helmet, values persist until the next page sets its own.
export default class Helmet extends Component {

  componentDidMount() {
    this.apply();
  }

  componentDidUpdate() {
    this.apply();
  }

  apply() {
    Children.forEach(this.props.children, (child) => {
      if (!child || !child.type) return;
      if (child.type === 'title') {
        document.title = child.props.children;
      } else if (child.type === 'meta' && child.props.id) {
        const tag = document.getElementById(child.props.id);
        if (tag) {
          tag.setAttribute('content', child.props.content);
        }
      }
    });
  }

  render() {
    return null;
  }
}

Helmet.propTypes = {
  children: PropTypes.node
};
